/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespComplementaryItemsGrid_item = {
    readonly complementaryItems?: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly title: string | null;
                readonly serviceId: string | null;
                readonly categoryPath: string | null;
                readonly categoryCode: string | null;
                readonly browseUrl: string | null;
                readonly ecommerceTrackingParams?: unknown | null;
                readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItem_item">;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "PdpRespComplementaryItemsGrid_item";
};
export type PdpRespComplementaryItemsGrid_item$data = PdpRespComplementaryItemsGrid_item;
export type PdpRespComplementaryItemsGrid_item$key = {
    readonly " $data"?: PdpRespComplementaryItemsGrid_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespComplementaryItemsGrid_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespComplementaryItemsGrid_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "complementaryItems",
          "storageKey": "complementaryItems(first:12)",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 12
            }
          ],
          "concreteType": "complementaryItemsConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "complementaryItemsEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Item",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "title",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "serviceId",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "categoryPath",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "categoryCode",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "browseUrl",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "Condition",
                      "passingValue": true,
                      "condition": "isClient",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "ecommerceTrackingParams",
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "userId",
                              "variableName": "userId"
                            }
                          ],
                          "storageKey": null
                        }
                      ]
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "PdpRespSimilarItem_item",
                      "args": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'cc0d9f89224bd4ac7e5ed99569b17dc7';
export default node;
